// https://react-spectrum.adobe.com/react-aria/useToast.html

import {ToastQueue} from "@react-stately/toast";
import type {ToastType} from "../Toast";

/**
 * Timeout for toasts in milliseconds.
 */
export const TOAST_TIMEOUT = 6000;

/**
 * A queue of toasts that are displayed in a toast region.
 */
export const toastQueue = new ToastQueue<ToastType>({
  maxVisibleToasts: 3,
});

/**
 * Show a toast message.
 */
export const showToast = (
  title: string,
  type = "info" as ToastType["type"],
  timeout?: number,
) => {
  toastQueue.add({title, type}, {timeout: timeout || TOAST_TIMEOUT});
};
